module.exports = __webpack_public_path__ + "img/aboutxcj.bf0dc153.png";